module.exports = __webpack_public_path__ + "img/7.9d274b5c.png";